// extracted by mini-css-extract-plugin
export default {"paymentMethod":"PaymentMethod_paymentMethod__U7uxJ","method":"PaymentMethod_method__jD9G4","icon":"PaymentMethod_icon__7hU3C"};